import React from 'react'
import { Link } from 'react-router-dom'
import { Icon } from '@iconify/react';
import Div from '../Div';

export default function SocialWidget() {
  return (
    <Div className="cs-social_btns cs-style1">
      
    
      <Link to='https://www.instagram.com/meghrajcinemaz/' className="cs-center">
        <Icon icon="fa6-brands:instagram" />              
      </Link>
      <Link to='https://www.facebook.com/p/Meghraj-cinemaz-61550102320293/' className="cs-center">
        <Icon icon="fa6-brands:facebook" />
      </Link>
    </Div>
  )
}
